import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  ownerInfo,
  surveyForm,
  healthWellbeing,
  nutritionDiet,
  healthGoals,
  behaviourLifestyle,
  medicationSupplement,
  personalityActivity,
  finalThoughts,
  Acknoledgement,
  maleQuestionary,
  femaleQuestionary,
} from "../jsonObject/surveyJson";
import { FaChevronDown } from "react-icons/fa";
import "./survey.css";
import {
  postPetSurvey,
  getPetSurveyByKitEmail,
  getDuplicateKitidCheck,
} from "../actions";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

function Survey() {
  const navigate = useNavigate();
  const token = localStorage.getItem("userInfo");
  const { id } = useParams();
  // Retrieve the is_kit_registered value from localStorage
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userInfo = JSON.parse(token);
  const [currentPage, setCurrentPage] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    StartTime: Date.now(), // Initial current time
    CompletionTime: null, // Can update on form submission
    Email: userInfo?.username || userInfo?.email || "",
    Name: "",
    // FullName: "",
    Kit_id: "",
    // KitID2: "",
    PetName: "",
    Gender: "",
    PetNeutered: "",
    PetSpayed: "",
    BreedingActivity: "",
    IsPregnant: "",
    Birthday: new Date("2000-01-01").getTime(), // Set to 0 or an empty string if no date is provided
    BreedType: "",
    BreedSize: "Small (6-25 lbs)",
    ReportToVet: "No",
    SoftStool: "No",
    SmallandHardStool: "No",
    LikeToHaveHealthyImmuneSystem: "No",
    DigestiveHealthConcerns: "No",
    DryCoatOrSkin: "No",
    FoodType: [],
    FavProteinSource: [],
    SpecialIngredients: [],
    AllergicIngredients: [],
    NoOfFeedsPerDay: "Free access all day",
    ConsumingSupplements: [],
    SupplementReplacement: "",
    HealthGoals: [],
    TopThreeHealthGoals: "",
    PetWeightInPounds: "",
    BodyCondition: "Ideal Weight (Visible waist and abdominal tuck)",
    OverThePastYear: "Gaining weight",
    IsWeightLossDueToIntentionalFeeding: "",
    IsWeightGainDueToIntentionalFeeding: "",
    HasMedicalConditions: [],
    HasUrinaryMedicalConditions: [],
    Anxietyconcern: "No",
    AnxietyDescription: "",
    SkinAndCoatRating: "Excellent",
    TearStaining: "No",
    PetMedications: "No",
    PetMedicationNames: "",
    PetPersonality: [],
    FrequentBarkingAtOthers: "No",
    WeekendWarrior: "No",
    PetAgeLook: "Acts older;",
    OtherInfo: "",
    IsAcknowledged: "No",
    imgBlob: "",
  });
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false); // Track overall form validity
  const [isPageValid, setIsPageValid] = useState(false); // Track validation of the current page
  const [successMessage, setSuccessMessage] = useState("");
  const dispatch = useDispatch();
  const { surveyResult, loading, error } = useSelector((state) => state.survey);
  const [imagePreview, setImagePreview] = useState(null);

  const pages = [
    { title: "Owner's information", fields: ownerInfo },
    { title: "About your dog", fields: surveyForm },
    { title: "Health & Well-being", fields: healthWellbeing },
    { title: "Nutrition & Diet", fields: nutritionDiet },
    { title: "Health Goals", fields: healthGoals },
    { title: "Behavior & Lifestyle", fields: behaviourLifestyle },
    { title: "Medications & Supplements", fields: medicationSupplement },
    { title: "Personality & Activity", fields: personalityActivity },
    { title: "Final Thoughts", fields: finalThoughts },
    { title: "Acknowledgement", fields: Acknoledgement },
  ];
  useEffect(() => {
    getSurvey();
  }, []);
  useEffect(() => {
    // Run validation every time formData changes
    validateForm();
  }, [formData]);

  useEffect(() => {
    validateCurrentPage();
  }, [formData, currentPage]);

  const getSurvey = async () => {
    try {
      // console.log("Fetching survey for email:", userInfo?.username || "", "and kit ID:", id || "");
      const response = await dispatch(
        getPetSurveyByKitEmail(
          userInfo?.username || userInfo?.email || "",
          id || ""
        )
      );
      console.log("Fetched survey response:", response);
      if (response?.data?.length > 0) {
        setIsEditing(true);
        const mappedForm = mapSurveyDataToForm(response);
        setFormData(mappedForm);
      }
    } catch (error) {
      console.error("Error fetching survey", error);
    }
  };
  const mapSurveyDataToForm = (apiData) => {
    const survey = apiData?.data?.[0];
    if (!survey) return formData; // fallback to default if no data

    return {
      ...formData,
      StartTime: survey.StartTime || formData.StartTime,
      CompletionTime: survey.CompletionTime || null,
      Email: survey.Email || formData.Email,
      Name: survey.Name || "",
      Kit_id: survey.Kit_id || "",
      PetName: survey.PetName || "",
      Gender: survey.Gender || "",
      PetNeutered: survey.PetNeutered || "",
      PetSpayed: survey.PetSpayed || "",
      BreedingActivity: survey.BreedingActivity || "",
      IsPregnant: survey.IsPregnant || "",
      Birthday: survey.Birthday
        ? new Date(survey.Birthday).getTime()
        : new Date("2000-01-01").getTime(),
      BreedType: survey.BreedType || "",
      BreedSize: survey.BreedSize || "Small (6-25 lbs)",
      ReportToVet: survey.ReportToVet || "No",
      SoftStool: survey.SoftStool || "No",
      SmallandHardStool: survey.SmallandHardStool || "No",
      LikeToHaveHealthyImmuneSystem:
        survey.LikeToHaveHealthyImmuneSystem || "No",
      DigestiveHealthConcerns: survey.DigestiveHealthConcerns || "No",
      DryCoatOrSkin: survey.DryCoatOrSkin || "No",
      FoodType: survey.FoodType || [],
      FavProteinSource: survey.FavProteinSource || [],
      SpecialIngredients: survey.SpecialIngredients || [],
      AllergicIngredients: survey.AllergicIngredients || [],
      NoOfFeedsPerDay: survey.NoOfFeedsPerDay || "Free access all day",
      ConsumingSupplements: survey.ConsumingSupplements || [],
      SupplementReplacement: survey.SupplementReplacement || "",
      HealthGoals: survey.HealthGoals || [],
      TopThreeHealthGoals: survey.TopThreeHealthGoals || "",
      PetWeightInPounds: survey.PetWeightInPounds || "",
      BodyCondition:
        survey.BodyCondition ||
        "Ideal Weight (Visible waist and abdominal tuck)",
      OverThePastYear: survey.OverThePastYear || "Gaining weight",
      IsWeightLossDueToIntentionalFeeding:
        survey.IsWeightLossDueToIntentionalFeeding || "",
      IsWeightGainDueToIntentionalFeeding:
        survey.IsWeightGainDueToIntentionalFeeding || "",
      HasMedicalConditions: survey.HasMedicalConditions || [],
      HasUrinaryMedicalConditions: survey.HasUrinaryMedicalConditions || [],
      Anxietyconcern: survey.Anxietyconcern || "No",
      AnxietyDescription: survey.AnxietyDescription || "",
      SkinAndCoatRating: survey.SkinAndCoatRating || "Excellent",
      TearStaining: survey.TearStaining || "No",
      PetMedications: survey.PetMedications || "No",
      PetMedicationNames: Array.isArray(survey.PetMedicationNames)
        ? survey.PetMedicationNames.join(', ')
        : survey.PetMedicationNames || "",
      PetPersonality: survey.PetPersonality || [],
      FrequentBarkingAtOthers: survey.FrequentBarkingAtOthers || "No",
      WeekendWarrior: survey.WeekendWarrior || "No",
      PetAgeLook: survey.PetAgeLook || "Acts older;",
      OtherInfo: survey.OtherInfo || "",
      IsAcknowledged: "No",
      imgBlob: survey.imgBase64 || "",
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "PetWeightInPounds") {
      // Allow empty string for backspace
      if (value === "") {
        setFormData((prev) => ({ ...prev, [name]: value }));
        return;
      }

      //handle max limit
      if (Number(value) >= 201) return;

      // Block zero or negative
      if (Number(value) <= 0) return;
    }
    if (name === "Birthday") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: new Date(value).getTime(),
      }));
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const handleMultiChange = (input) => {
    const name = input.target?.name || input.name;
    const value = input.target?.value || input.value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    console.log("name", name);
  };

  const validateField = (name, value) => {
    let fieldErrors = "";

    // Skip validation for hidden conditional fields
    if (name === "AnxietyDescription" && formData.Anxietyconcern !== "Yes") {
      return ""; // Not required if Anxietyconcern is No
    }
    if (name === "PetMedicationNames" && formData.PetMedications !== "Yes") {
      return ""; // Not required if PetMedications is No
    }

    if (name === "imgBlob") {
      return ""; // No error
    }
    if (name === "SupplementReplacement") {
      return "";
    }

    const isEmptyValue = (val) => {
      if (val === null || val === undefined) return true;
      if (Array.isArray(val)) {
        return val.length === 0 || val.every((item) => String(item).trim() === "");
      }
      return String(val).trim() === "";
    };

    // Conditional required logic
    if (
      name === "AnxietyDescription" &&
      formData.Anxietyconcern === "Yes" &&
      isEmptyValue(value)
    ) {
      fieldErrors = "Please provide details about your concerns.";
    } else if (
      name === "PetMedicationNames" &&
      formData.PetMedications === "Yes" &&
      isEmptyValue(value)
    ) {
      fieldErrors = "Please provide medication names.";
    } else if (name === "Kit_id") {
      if (!/^\d{14}$/.test(value)) {
        fieldErrors = "Kit ID must be exactly 14 digits.";
      }
    } else if (!value) {
      fieldErrors = "This field is required.";
    }

    return fieldErrors;
  };

  const validateForm = () => {
    const fieldErrors = {};
    for (const page of pages) {
      page.fields.forEach((field) => {
        fieldErrors[field.fieldName] = validateField(
          field.fieldName,
          formData[field.fieldName] || ""
        );
      });
    }
    setErrors(fieldErrors);
    setIsFormValid(Object.values(fieldErrors).every((error) => !error));
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    const file = files[0];
    const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
    if (!validTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Only image files (JPG, PNG, GIF) are allowed",
      }));
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setErrors((prev) => ({ ...prev, [name]: "File size exceeds 2MB limit" }));
      return;
    }
    const base64string = await fileToBase64(file);
    setImagePreview(base64string);
    setFormData((prev) => ({ ...prev, [name]: file }));
    setErrors((prev) => {
      const { [name]: _, ...rest } = prev;
      return rest;
    });
  };

  const fileToBase64 = (file) => {
    const result = new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
    console.log(result);
    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("isSubmitting", isSubmitting);

    if (isSubmitting) return; // Prevent double submission

    // Validate form before proceeding
    if (!isFormValid) {
      console.warn("Form is not valid");
      return;
    }

    setIsSubmitting(true);

    // Create a local copy of formData with updated CompletionTime
    let updatedFormData = {
      ...formData,
      CompletionTime: Date.now(),
    };

    // Convert image blob to base64 if needed
    const convertBlobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    try {
      if (updatedFormData.imgBlob) {
        if (
          updatedFormData.imgBlob instanceof Blob ||
          updatedFormData.imgBlob instanceof File
        ) {
          updatedFormData.imgBase64 = await convertBlobToBase64(
            updatedFormData.imgBlob
          );
        } else if (typeof updatedFormData.imgBlob === "string") {
          updatedFormData.imgBase64 = updatedFormData.imgBlob; // Already base64
        }
        delete updatedFormData.imgBlob; // Remove raw blob
      }

      // Validate form before sending
      if (isFormValid) {
        if (Array.isArray(updatedFormData.PetMedicationNames)) {
          updatedFormData.PetMedicationNames = updatedFormData.PetMedicationNames.join(', ');
        }
        const response = await dispatch(postPetSurvey(updatedFormData));
        console.log("Response from postPetSurvey:", response);

        if (response?.message) {
          setSuccessMessage(response.message);
          navigate("/home");
        }
      } else {
        console.warn("Form is not valid");
      }
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const validateCurrentPage = async () => {
    const currentErrors = {};
    const currentFields = pages[currentPage].fields;

    currentFields.forEach((field) => {
      currentErrors[field.fieldName] = validateField(
        field.fieldName,
        formData[field.fieldName] || ""
      );
    });

    if (
      !isEditing &&
      currentPage === 0 &&
      formData.Kit_id &&
      !currentErrors.Kit_id
    ) {
      try {
        const response = await dispatch(
          getDuplicateKitidCheck(formData.Kit_id)
        );
        if (response?.exists) {
          currentErrors.Kit_id = "Kit ID is already registered.";
        } else {
          currentErrors.Kit_id = "";
        }
      } catch (error) {
        console.error("Error checking Kit ID duplication:", error);
        currentErrors.Kit_id = "Error validating Kit ID.";
      }
    }
    setErrors((prevErrors) => ({ ...prevErrors, ...currentErrors }));

    // Check if all fields on the current page are valid
    const pageIsValid = Object.values(currentErrors).every((error) => !error);
    setIsPageValid(pageIsValid);
  };

  const handleNextPage = () => {
    const currentErrors = {};
    const currentFields = pages[currentPage].fields;
    currentFields.forEach((field) => {
      currentErrors[field.fieldName] = validateField(
        field.fieldName,
        formData[field.fieldName] || ""
      );
    });
    setErrors((prevErrors) => ({ ...prevErrors, ...currentErrors }));
    if (isPageValid) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
    // if (currentPage < pages.length - 1) {
    //     setCurrentPage(prevPage => prevPage + 1);
    // }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const renderAdditionalFields = () => {
    if (formData.Gender === "Male") {
      return maleQuestionary.map((field, index) => (
        <Form.Group
          className="fieldSurvey"
          key={index}
          controlId={field.fieldName}
        >
          <Form.Label className="labelSurvey">{field.label}</Form.Label>
          {renderField(field)}
        </Form.Group>
      ));
    } else if (formData.Gender === "Female") {
      return femaleQuestionary.map((field, index) => (
        <Form.Group
          className="fieldSurvey"
          key={index}
          controlId={field.fieldName}
        >
          <Form.Label className="labelSurvey">{field.label}</Form.Label>
          {renderField(field)}
        </Form.Group>
      ));
    }
    return null;
  };

  const renderField = (field) => {
    const error = errors[field.fieldName]
      ? String(errors[field.fieldName])
      : "";

    const readOnlyFields = ["Kit_id", "Email"];

    if (isEditing) readOnlyFields.push("Name");

    const isReadOnly = readOnlyFields.includes(field.fieldName);

    switch (field.fieldType) {
      case "text":
        return (
          <div>
            <Form.Control
              className="inputSurvey"
              type="text"
              name={field.fieldName}
              value={formData[field.fieldName] || ""}
              onChange={handleChange}
              readOnly={isReadOnly}
            />
            {error && <small className="error-text">{error}</small>}
          </div>
        );

      case "number":
        return (
          <div>
            <Form.Control
              className="inputSurvey"
              type="number"
              name={field.fieldName}
              min="1" // Prevent negative values
              value={formData[field.fieldName] || ""}
              onbl
              onChange={handleChange}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "+" ||
                  e.key === "-"
                ) {
                  e.preventDefault();
                }
              }}
            />
            {error && <small className="error-text">{error}</small>}
          </div>
        );

      case "textarea":
        return (
          <div>
            <Form.Control
              className="inputSurvey"
              as="textarea"
              name={field.fieldName}
              value={formData[field.fieldName] || ""}
              onChange={handleChange}
            />
            {error && <small className="error-text">{error}</small>}
          </div>
        );
      case "radio":
        return field.options.map((option) => (
          <Form.Check
            className="radioSurvey"
            key={option}
            type="radio"
            label={option}
            name={field.fieldName}
            value={option}
            checked={formData[field.fieldName] === option}
            onChange={handleChange}
          />
        ));
      case "select":
        return (
          <div className="custom-select-wrapper">
            <Form.Control
              className="selectInputSurvey"
              as="select"
              name={field.fieldName}
              value={formData[field.fieldName] || ""}
              onChange={handleChange}
            >
              {field.options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </Form.Control>
            <FaChevronDown className="dropdown-icon" size={20} />
            {error && <small className="error-text">{error}</small>}
          </div>
        );
      case "multiselect":
        const dynamicOptions =
          field.fieldName === "TopThreeHealthGoals"
            ? formData.HealthGoals.map((goal) => ({ label: goal, value: goal }))
            : field.options.map((option) => ({ label: option, value: option }));

        return (
          <div className="custom-multiselect-wrapper">
            <Select
              isMulti
              name={field.fieldName}
              options={dynamicOptions}
              value={
                Array.isArray(formData[field.fieldName]) &&
                  formData[field.fieldName].length > 0
                  ? formData[field.fieldName].map((val) => ({
                    label: val,
                    value: val,
                  }))
                  : null
              }
              onChange={(selectedOptions) => {
                const values = (selectedOptions || []).map(
                  (option) => option.value
                );
                handleMultiChange({
                  target: { name: field.fieldName, value: values },
                });
              }}
              className="react-select-container"
              classNamePrefix="react-select"
            />
            {error && <small className="error-text">{error}</small>}
          </div>
        );
      case "file":
        return (
          <div>
            {(formData.imgBlob || imagePreview) && (
              <div className="image-preview">
                <img
                  src={!imagePreview ? formData.imgBlob : imagePreview}
                  alt="Uploaded preview"
                  style={{
                    maxWidth: "10%",
                    height: "auto",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <Form.Control
              className="inputSurvey"
              type="file"
              name={field.fieldName}
              accept="image/*"
              onChange={handleFileChange}
            />
            {error && <small className="error-text">{error}</small>}

            <Form.Text id={`${field.fieldName}-help`} muted className="d-block mt-1">
              Note: Only image files (JPG, PNG, GIF) are allowed. Max size: 2MB.
            </Form.Text>
          </div>
        );

      case "date":
        return (
          <div>
            <Form.Control
              className="inputSurvey"
              type="date"
              name={field.fieldName}
              value={
                field.fieldName === "Birthday"
                  ? (formData.Birthday && new Date(formData.Birthday).toISOString().split("T")[0])
                  : formData[field.fieldName] || ""
              }
              onChange={handleChange}
              min="2000-01-01" // Restrict to dates from year 2000
              max={new Date().toISOString().split("T")[0]}
              onKeyDown={(e) => e.preventDefault()}
            />
            {error && <small className="error-text">{error}</small>}
          </div>
        );

      default:
        return null;
    }
  };

  const renderCurrentPage = () => {
    const page = pages[currentPage];

    return (
      <div>
        <h2 className="surveySectionHeading">{page.title}</h2>

        {page.fields.map((field, index) =>
          (field.fieldName === "AnxietyDescription" &&
            formData.Anxietyconcern !== "Yes") ||
            (field.fieldName === "PetMedicationNames" &&
              formData.PetMedications !== "Yes") ? null : (
            <div key={index}>
              <Form.Group className="fieldSurvey" controlId={field.fieldName}>
                <Form.Label className="labelSurvey">{field.label}</Form.Label>
                {renderField(field)}
              </Form.Group>
              {field.fieldName === "ReportToVet" &&
                formData.ReportToVet === "Yes" && (
                  <>
                    <Form.Group className="fieldSurvey" controlId="emailVet">
                      <Form.Label className="labelSurvey">
                        If yes, please provide the email address?
                      </Form.Label>
                      <Form.Control
                        className="inputSurvey"
                        type="text"
                        name="emailVet"
                        value={formData.emailVet || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Form.Group className="fieldSurvey" controlId="contactVet">
                      <Form.Label className="labelSurvey">
                        If yes, please provide the contact details?
                      </Form.Label>
                      <Form.Control
                        className="inputSurvey"
                        type="number"
                        name="contactVet"
                        value={formData.contactVet || ""}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </>
                )}
            </div>
          )
        )}

        {currentPage === 1 && renderAdditionalFields()}
      </div>
    );
  };

  return (
    <div>
      <div className="Surveyform">
        <div className="Surveyform-container">
          <h1>Survey Form</h1>
        </div>
        <div className="Surveyform-fields">
          <Form onSubmit={handleSubmit}>
            {renderCurrentPage()}
            <div>
              <div
                className="pagination-buttons"
                style={{
                  display: "flex",
                  justifyContent:
                    currentPage === 0 ? "flex-end" : "space-between",
                }}
              >
                {currentPage > 0 && (
                  <Button
                    className="previous-button"
                    type="button"
                    onClick={handlePreviousPage}
                    variant="secondary"
                  >
                    Previous
                  </Button>
                )}
                {currentPage < pages.length - 1 ? (
                  <Button
                    className="submit-button"
                    onClick={handleNextPage}
                    type="button"
                    variant="primary"
                    disabled={!isPageValid}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    className="submit-button"
                    type="submit"
                    disabled={!isPageValid || formData.IsAcknowledged !== "Yes"}
                  >
                    {isEditing ? "Update" : "Submit"}
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </div>
      </div>
      {successMessage && (
        <div className="alert alert-success" role="alert">
          {successMessage}
        </div>
      )}
    </div>
  );
}

export default Survey;
